import { fromJS } from 'immutable'
import * as tags from './contentAssetTagsActions'

const initialState = fromJS({
	isLoading: false,
	isCreating: false,
	loaded: false,
	tags: []
})

const contentAssetTagsReducer = (state = initialState, action) => {
	switch (action.type) {
		case tags.IS_LOADING_TAGS: {
			return state.set('isLoading', action.status)
		}
		case tags.SET_TAGS: {
			return state.set('tags', fromJS(action.data)).set('loaded', true)
		}
		case tags.IS_CREATING_TAG: {
			return state.set('isCreating', action.status)
		}
		case tags.ADD_TAG: {
			const current = state.get('tags').toJS()
			return state.set('tags', fromJS([...current, action.tag]))
		}
		default:
			return state
	}
}

export default contentAssetTagsReducer
